import {
    ADMINDELETEBANKMAPPING_SUCCESS,
    ADMINDELETEBANKMAPPING_FAILED,
    RESET_ADMINDELETEBANKMAPPING,
    LOADING_ADMINDELETEBANKMAPPING,
    NETWORK_ERROR_ADMINDELETEBANKMAPPING
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINDELETEBANKMAPPING:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINDELETEBANKMAPPING_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINDELETEBANKMAPPING_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINDELETEBANKMAPPING:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINDELETEBANKMAPPING:
            return (state = initialState);
        default:
            return state;
    }
};
